import React, { useEffect, useState } from 'react';

const BackButton = () => {
    const [sameDomain, setSameDomain] = useState(false);

    useEffect(() => {
        const referrer = document.referrer;
        const currentDomain = window.location.host;
        const isFromSameDomain = referrer.includes(currentDomain);

        setSameDomain(isFromSameDomain);
    }, []);

    if (!sameDomain) {
        return null;
    }

    return (
        <button className={'button button--primary'} onClick={() => window.history.back()}>« zurück</button>
    );
};

export default BackButton;